import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { ModalChiTietPhiHangKy } from "./ModalChiTietPhiHangKy";

export const BtnChiTietPhiHangKy = ({ item }) => {
  const [show, setShow] = useState(false);

  if (!item.OtheFeeHangKy) {
    return <>{formatNumber(item.OtheFeeHangKy)}</>;
  }
  return (
    <>
      <a
        onClick={() => setShow(true)}
        href={() => false}
        className="blue btn-link"
      >
        {formatNumber(item.OtheFeeHangKy)}
      </a>
      {show && (
        <ModalChiTietPhiHangKy
          show={show}
          onHide={() => setShow(false)}
          item={item}
        />
      )}
    </>
  );
};
